const awsmobile = {
  aws_project_region: "eu-central-1",
  aws_appsync_graphqlEndpoint: "https://gh2m43w325h57ie7bg5vd6ftf4.appsync-api.eu-central-1.amazonaws.com/graphql",
  aws_appsync_region: "eu-central-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_cognito_identity_pool_id: "eu-central-1:b38b944e-4f1a-4297-9fae-3efca498ae5a",
  aws_cognito_region: "eu-central-1",
  aws_user_pools_id: "eu-central-1_lkUgNPoNr",
  aws_user_pools_web_client_id: "1tlovkpt0um3r8boheap01a5kv",
  oauth: {
    domain: "dancehub.auth.eu-central-1.amazoncognito.com",
    scope: ["email", "openid", "profile"],
    redirectSignIn: "https://dancehub.me/,https://www.dancehub.me/,http://localhost:3000/",
    redirectSignOut: "https://dancehub.me/,https://www.dancehub.me/,http://localhost:3000/",
    responseType: "code"
  },
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: ["GOOGLE"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  Auth: {
    Cognito: {
      userPoolId: "eu-central-1_lkUgNPoNr",
      userPoolClientId: "1tlovkpt0um3r8boheap01a5kv",
      loginWith: {
        oauth: {
          domain: "dancehub.auth.eu-central-1.amazoncognito.com",
          scopes: ["email", "openid", "profile"],
          redirectSignIn: ["https://dancehub.me/", "https://www.dancehub.me/", "http://localhost:3000/"],
          redirectSignOut: ["https://dancehub.me/", "https://www.dancehub.me/", "http://localhost:3000/"],
          responseType: "code",
          providers: ["Google"]
        }
      }
    }
  }
};

export default awsmobile;
